import axios from "axios";
import { toastr } from "react-redux-toastr";
import {
    FETCH_LOADING,
    FETCH_ERROR,
    FETCH_ONE_PRODUCT,
    FETCH_SEARCH,
    FETCH_PRODUCTS,
} from "../types/types";

export const FetchProducts = () => async (dispatch) => {
    dispatch({ type: FETCH_LOADING });
    axios
        .get("https://shoppi-test.herokuapp.com/api/get/products")
        .then((result) => {
            dispatch({
                type: FETCH_PRODUCTS,
                payload: result.data,
            });
        })
        .catch((err) => {
            dispatch({
                type: FETCH_ERROR,
                payload: err.message,
            });
            toastr.error("Product not found error");
        });
};

export const FetchSearch = (data) => async (dispatch) => {
    dispatch({ type: FETCH_LOADING });
    axios
        .get(`https://shoppi-test.herokuapp.com/api/get/search/products?title=${data}`)
        .then((result) => {
            dispatch({
                type: FETCH_SEARCH,
                payload: result.data,
                data: data,
            });
        })
        .catch((err) => {
            dispatch({
                type: FETCH_ERROR,
                payload: err.response.data,
            });
            toastr.error(err.response.data);
        });
};

export const FetchOneProduct = (id) => async (dispatch) => {
    dispatch({ type: FETCH_LOADING });
    axios
        .get(`https://shoppi-test.herokuapp.com/api/get/product?id=${id}`)
        .then((result) => {
            dispatch({
                type: FETCH_ONE_PRODUCT,
                payload: result.data,
            });
        })
        .catch((err) => {
            dispatch({
                type: FETCH_ERROR,
                payload: err.response.data,
            });
            toastr.error(err.response.data);
        });
};
